import { ApplicationFeeProtocol } from './application-fee-protocol.js';
import { InvoiceVat } from '../invoicing/invoice-vat.js';
import { GiftCardSellingSettings } from '../gift-card-selling-settings.js';
import { GenericOrderGiftCardEntry } from '../orders/generic-order-entries/generic-order-gift-card-entry.js';
import { Price } from '../price.js';
import { GiftCard } from '../gift-card/gift-card.js';
import { Fee } from '../fee.js';

export class GiftCardFeeProvider {
  private readonly standardFee: ApplicationFeeProtocol | null;

  constructor(settings: GiftCardSellingSettings) {
    this.standardFee = settings.feeProtocol;
  }

  getFeeVatOverride(): InvoiceVat | null {
    return this.standardFee?.overrideVat ?? null;
  }

  getFeeForGiftCard(giftCard: GiftCard): Fee | null {
    return this.standardFee?.getUnitFee(giftCard.price) ?? null;
  }

  calculateFeeForGiftCardOrderEntry(entry: GenericOrderGiftCardEntry): Price | null {
    let totalFee: Price | null = null;

    for(const giftCard of entry.giftCards) {
      const fee = this.calculateFeeForGiftCard(giftCard);
      if(fee != null) {
        totalFee = totalFee != null ? totalFee.add(fee) : fee;
      }
    }

    return totalFee;
  }

  private calculateFeeForGiftCard(giftCard: GiftCard): Price | null {
    let fee: Price | null = null;

    if(this.standardFee != null) {
      fee = this.standardFee.calculateUnitFee(giftCard.price);
    }

    return fee?.isPositive() === true ? fee : null;
  }
}
